// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-car
 * @tagname hzn-icon-car
 * @summary An individual icon for Horizon
 */
export class HznIconCar extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.10557 3.55279C5.27496 3.214 5.62123 3 6 3H18C18.3788 3 18.725 3.214 18.8944 3.55279L21.8944 9.55279C21.9639 9.69164 22 9.84476 22 10V17V19C22 19.5523 21.5523 20 21 20H20C19.4477 20 19 19.5523 19 19V18H5V19C5 19.5523 4.55228 20 4 20H3C2.44772 20 2 19.5523 2 19V17V10C2 9.84476 2.03615 9.69164 2.10557 9.55279L5.10557 3.55279ZM6.61803 5L4.61803 9H19.382L17.382 5H6.61803ZM20 11H4V16H20V11ZM6.5 15C7.32843 15 8 14.3284 8 13.5C8 12.6716 7.32843 12 6.5 12C5.67157 12 5 12.6716 5 13.5C5 14.3284 5.67157 15 6.5 15ZM17.5 15C18.3284 15 19 14.3284 19 13.5C19 12.6716 18.3284 12 17.5 12C16.6716 12 16 12.6716 16 13.5C16 14.3284 16.6716 15 17.5 15Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=car.js.map